import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  PhoneAuthProvider,
  signInWithCredential,
  signInWithCustomToken,
  signOut,
} from "firebase/auth";

// Update this config with your new Firebase project credentials
// Get these from Firebase Console > Project Settings > General > Your apps
const firebaseConfig = {
  apiKey: "AIzaSyBXPh3oLn5M9UBcoSQwL08AbflgpcIzqu4",
  authDomain: "pukaar-playstore-app.firebaseapp.com",
  projectId: "pukaar-playstore-app",
  storageBucket: "pukaar-playstore-app.firebasestorage.app",
  messagingSenderId: "148226781747",
  appId: "1:148226781747:web:e20946bdf2ace0cfd6e946",
  measurementId: "G-79J98ERKZ6",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export {
  auth,
  provider,
  GoogleAuthProvider,
  RecaptchaVerifier,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  signInWithPhoneNumber,
  PhoneAuthProvider,
  signInWithCredential,
  signInWithCustomToken,
  signOut,
};
